/* ==========================================================================
   KRYPTIK INDUSTRIES — theme script
   Vanilla JS. No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var K = window.KRYPTIK || {};
  var strings = K.strings || {};
  var root = (K.routes && K.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || K.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function setExpanded(id, value) {
    $$('[aria-controls="' + id + '"]').forEach(function (el) { el.setAttribute('aria-expanded', value); });
  }

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    $$('.drawer.is-open').forEach(function (d) { if (d !== drawer) closeDrawer(d, true); });
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    setExpanded(id, 'true');
    var target = drawer.querySelector('[data-autofocus]') || drawer.querySelector('.drawer__panel ' + FOCUSABLE.split(',')[1]) || drawer.querySelector('.drawer__panel');
    window.setTimeout(function () { if (target) target.focus({ preventScroll: true }); }, 80);
    return true;
  }

  function closeDrawer(drawer, silent) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    setExpanded(drawer.id, 'false');
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('is-locked');
    if (!silent && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-drawer-open'))) event.preventDefault();
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var open = $('.drawer.is-open');
    if (event.key === 'Escape') {
      if (open) closeDrawer(open);
      $$('details[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
      return;
    }
    if (event.key === 'Tab' && open) {
      var items = $$(FOCUSABLE, open.querySelector('.drawer__panel')).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  /* Desktop dropdowns: one open at a time, close on outside click */
  document.addEventListener('click', function (event) {
    $$('details[data-dropdown][open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });
  $$('details[data-dropdown]').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      $$('details[data-dropdown][open]').forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
    });
  });

  /* ---------- Header ---------- */
  var header = $('[data-site-header]');
  if (header) {
    var wrap = header.closest('.shopify-section');
    if (wrap && header.classList.contains('site-header--sticky')) wrap.classList.add('is-sticky');
    var reveal = header.classList.contains('site-header--reveal');
    var ticking = false;
    var onScroll = function () {
      var threshold = reveal ? window.innerHeight * 0.5 : 12;
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();
  }

  /* ---------- Whisper bar ---------- */
  $$('[data-whisper-bar]').forEach(function (bar) {
    var msgs = $$('.whisper-bar__msg', bar);
    if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    var interval = (parseInt(bar.getAttribute('data-interval'), 10) || 6) * 1000;
    window.setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Hero descend ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-descend]');
    if (!btn) return;
    var section = btn.closest('.shopify-section');
    var next = section && section.nextElementSibling;
    if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Cart ---------- */
  var Cart = {
    sectionId: 'cart-drawer',

    setCount: function (count) {
      count = parseInt(count, 10) || 0;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },

    render: function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CartDrawerInner');
      var current = document.getElementById('CartDrawerInner');
      if (!fresh || !current) return;
      var focusKey = document.activeElement && document.activeElement.getAttribute('data-focus-key');
      current.replaceWith(fresh);
      this.setCount(fresh.getAttribute('data-count'));
      if (focusKey) {
        var again = fresh.querySelector('[data-focus-key="' + focusKey + '"]');
        if (again) again.focus({ preventScroll: true });
        else {
          var close = fresh.querySelector('[data-drawer-close]');
          if (close) close.focus({ preventScroll: true });
        }
      }
    },

    refresh: function (sections) {
      if (sections && sections[this.sectionId]) {
        this.render(sections[this.sectionId]);
        return Promise.resolve();
      }
      var self = this;
      return fetch(root + '?sections=' + this.sectionId, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) { self.render(json[self.sectionId]); });
    },

    add: function (formData) {
      formData.append('sections', this.sectionId);
      formData.append('sections_url', window.location.pathname);
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      }).then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw new Error(json.description || json.message || strings.cartError);
          return json;
        });
      });
    },

    change: function (line, quantity) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [this.sectionId], sections_url: window.location.pathname })
      }).then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw new Error(json.description || json.message || strings.cartError);
          return json;
        });
      });
    }
  };
  window.KryptikCart = Cart;

  var hasDrawer = function () { return K.cartType === 'drawer' && document.getElementById('CartDrawer'); };

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form || !hasDrawer()) return;
    event.preventDefault();
    var button = form.querySelector('[data-add-button]');
    var error = form.querySelector('[data-form-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

    Cart.add(new FormData(form))
      .then(function (json) { return Cart.refresh(json.sections); })
      .then(function () { openDrawer('CartDrawer'); })
      .catch(function (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      })
      .then(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = button.getAttribute('data-sold-out') === 'true';
        }
      });
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cart-qty]');
    if (!btn) return;
    event.preventDefault();
    var inner = document.getElementById('CartDrawerInner');
    if (inner) inner.classList.add('is-busy');
    Cart.change(parseInt(btn.getAttribute('data-line'), 10), Math.max(0, parseInt(btn.getAttribute('data-cart-qty'), 10) || 0))
      .then(function (json) { return Cart.refresh(json.sections); })
      .catch(function (err) {
        var box = document.querySelector('[data-cart-error]');
        if (box) { box.textContent = err.message; box.hidden = false; }
      })
      .then(function () {
        var current = document.getElementById('CartDrawerInner');
        if (current) current.classList.remove('is-busy');
      });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var value = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product: gallery + variants ---------- */
  function initGallery(scope) {
    var track = scope.querySelector('[data-gallery-track]');
    if (!track) return null;
    var thumbs = $$('[data-thumb]', scope);
    function show(mediaId, smooth) {
      var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId)); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.getAttribute('data-thumb')); });
    });
    var timer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        var slide = track.children[index];
        if (!slide) return;
        var id = slide.getAttribute('data-media-id');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
      }, 90);
    }, { passive: true });
    return show;
  }

  function initProduct(scope) {
    if (scope.__kryptikReady) return;
    scope.__kryptikReady = true;
    var showMedia = initGallery(scope);
    var selected = scope.getAttribute('data-selected-media');
    if (showMedia && selected) showMedia(selected, false);

    var dataEl = scope.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = scope.querySelector('form[data-product-form]');
    var fieldsets = $$('[data-option-index]', scope);
    if (!fieldsets.length) return;

    function currentOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability(options) {
      fieldsets.forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var test = options.slice();
          test[index] = input.value;
          var possible = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !possible);
        });
      });
    }

    function update() {
      var options = currentOptions();
      fieldsets.forEach(function (fs, i) {
        var out = fs.querySelector('[data-option-value]');
        if (out) out.textContent = options[i] || '';
      });
      markAvailability(options);
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
      var button = form && form.querySelector('[data-add-button]');
      var label = button && button.querySelector('[data-add-label]');
      if (!variant) {
        if (button) { button.disabled = true; button.setAttribute('data-sold-out', 'true'); }
        if (label) label.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      var idInput = form && form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      if (button) {
        button.disabled = !variant.available;
        button.setAttribute('data-sold-out', String(!variant.available));
      }
      if (label) label.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');

      var priceBox = scope.querySelector('[data-price]');
      if (priceBox) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceBox.innerHTML =
          '<span class="price' + (onSale ? ' price--sale' : '') + '"><span class="price__now">' + escapeHtml(formatMoney(variant.price)) + '</span>' +
          (onSale ? '<s class="price__was"><span class="visually-hidden">Regular price</span>' + escapeHtml(formatMoney(variant.compare_at_price)) + '</s>' : '') +
          '</span>';
      }
      if (showMedia && variant.featured_media) showMedia(variant.featured_media.id);
      if (scope.getAttribute('data-update-url') === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    markAvailability(currentOptions());
  }

  $$('[data-product-root]').forEach(initProduct);

  /* ---------- Recommendations ---------- */
  function loadRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.__loaded) return;
    el.__loaded = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }
  $$('[data-recommendations]').forEach(function (el) {
    if (!('IntersectionObserver' in window)) { loadRecommendations(el); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { loadRecommendations(el); io.disconnect(); }
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  });

  /* ---------- Facets ---------- */
  $$('[data-facet-form]').forEach(function (form) {
    function submit() {
      $$('input[type="number"]', form).forEach(function (input) { input.disabled = input.value === ''; });
      form.submit();
    }
    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="checkbox"], select, input[type="number"]')) submit();
    });
    form.addEventListener('submit', function () {
      $$('input[type="number"]', form).forEach(function (input) { input.disabled = input.value === ''; });
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = $('[data-predictive-input]');
  var results = $('[data-predictive-results]');
  if (searchInput && results) {
    var debounce;
    var lastQuery = '';
    searchInput.addEventListener('input', function () {
      window.clearTimeout(debounce);
      var q = searchInput.value.trim();
      if (q.length < 2) { results.innerHTML = ''; lastQuery = ''; return; }
      debounce = window.setTimeout(function () {
        lastQuery = q;
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            if (q !== lastQuery) return;
            var products = (json.resources && json.resources.results && json.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<p class="predictive__empty">' + escapeHtml(strings.noResults || 'No results.') + '</p>';
              return;
            }
            var html = products.map(function (p) {
              var price = Math.round(parseFloat(p.price) * 100);
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              return '<a class="predictive__item" href="' + escapeHtml(p.url) + '">' +
                (img ? '<img src="' + escapeHtml(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="52" height="64" loading="lazy">' : '') +
                '<span><span class="predictive__title">' + escapeHtml(p.title) + '</span>' +
                '<span class="predictive__price">' + escapeHtml(formatMoney(price)) + '</span></span></a>';
            }).join('');
            var searchUrl = ((K.routes && K.routes.search) || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
            results.innerHTML = html + '<a class="predictive__all" href="' + escapeHtml(searchUrl) + '">See all results</a>';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', function (event) {
    $$('[data-product-root]', event.target).forEach(initProduct);
    $$('[data-recommendations]', event.target).forEach(loadRecommendations);
  });
  document.addEventListener('shopify:section:select', function (event) {
    var drawer = event.target.querySelector('.drawer');
    if (drawer && event.target.id.indexOf('cart-drawer') > -1) openDrawer(drawer.id);
  });
})();
